import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_2 = {
  key: 0,
  class: "w-full"
}
const _hoisted_3 = {
  key: 1,
  class: "page-title transform -translate-y-1"
}

import { ref, computed, inject, onMounted } from 'vue';
import { Layout } from 'ant-design-vue';
import { useStore } from '@/store';
import { MainWrapper } from '@/layouts/style';
import AsideItems from '@/components/Aside.vue';
import AuthInfo from '@/components/utilities/auth-info/info.vue';
import TrialBanner from '@/components/uiv2/TrialBanner.vue';
import ErrorBoundary from '@/components/ErrorBoundary.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const { Header, Sider, Content } = Layout;
const store = useStore();

const collapsed = ref(window.innerWidth <= 1200);

const toggleCollapsed = (e: Event) => {
  e.preventDefault();
  collapsed.value = !collapsed.value;
};

const end = computed(() => store.getters['subscription/endDate']);
const subscriptionStatus = computed(() => store.getters['subscription/status']);
const isCanceledByUser = computed(() => store.getters['subscription/isCanceledByUser']);
const isInstitutionalAdmin = computed(() => store.getters.currentUserRoles?.includes('institutional_admin'));

const isUserLoaded = computed(() => !!store.getters.activeInstitutionId);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_router_view = _resolveComponent("router-view")!

  return (isUserLoaded.value)
    ? (_openBlock(), _createBlock(_unref(MainWrapper), {
        key: 0,
        "dark-mode": true,
        style: {"height":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Layout), {
            class: "layout",
            style: {"min-height":"100%","padding-right":"24px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Sider), {
                width: 270,
                style: {
          margin: '0 0 0 0',
          padding: '15px 15px 15px 15px',
          overflowY: 'auto',
          height: '100vh',
          position: 'fixed',
          zIndex: 998,
        },
                breakpoint: "xl",
                "collapsed-width": "0",
                theme: "dark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "logo-container"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(AsideItems, {
                    "top-menu": false,
                    "dark-mode": true,
                    "toggle-collapsed": toggleCollapsed,
                    style: { color: 'black' }
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(Layout), { class: "atbd-main-layout" }, {
                default: _withCtx(() => [
                  (
            isInstitutionalAdmin.value && (subscriptionStatus.value === 'TRIAL_ACTIVE' || subscriptionStatus.value === 'GRACE_PERIOD')
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(TrialBanner, {
                          "is-canceled-by-user": isCanceledByUser.value,
                          status: subscriptionStatus.value,
                          end: end.value
                        }, null, 8, ["is-canceled-by-user", "status", "end"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(Header), { style: {
            width: '100%',
            top: 0,
            left: 0,
            paddingTop: '6px',
            backgroundColor: '#f4f5f7',
          } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            lg: 8,
                            sm: 10,
                            xs: 12,
                            class: "navbar-brand",
                            style: {"padding-left":"34px"}
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                (_ctx.$route.meta?.backToTitle)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      style: {"cursor":"pointer","font-size":"15px","color":"blue","margin-top":"0"},
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$route.meta?.backToUrl ? _ctx.$router.push(_ctx.$route.meta.backToUrl) : _ctx.$router.go(-1)))
                                    }, _toDisplayString(`< ${_ctx.$t(`titles.${_ctx.$route.meta.backToTitle}`)}`), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t(`titles.${String(_ctx.$route.name).toLowerCase()}`)), 1))
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            lg: 10,
                            md: 8,
                            sm: 0,
                            xs: 0
                          }),
                          _createVNode(_component_a_col, {
                            lg: 6,
                            md: 10,
                            sm: 0,
                            xs: 0
                          }, {
                            default: _withCtx(() => [
                              _createVNode(AuthInfo)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            md: 0,
                            sm: 18,
                            xs: 12,
                            style: { position: 'static' }
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Content), { style: {"padding":"24px 0 24px 24px"} }, {
                    default: _withCtx(() => [
                      _createVNode(ErrorBoundary, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_view)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})